document.querySelectorAll('[data-guide-calculator]').forEach(panel => {
  const form = panel.querySelector('[data-volume-form]');
  form.addEventListener('submit', event => {
    event.preventDefault();
    if (!form.reportValidity()) return;
    const values = ['length', 'width', 'depth'].map(name => Number(form.elements.namedItem(name).value));
    if (values.some(value => !Number.isFinite(value) || value <= 0)) return;
    const cubicFeet = values[0] * values[1] * values[2] / 12;
    panel.querySelector('[data-volume-feet]').textContent = cubicFeet.toLocaleString(undefined, {maximumFractionDigits:2});
    panel.querySelector('[data-volume-gallons]').textContent = (cubicFeet * 7.48051948).toLocaleString(undefined, {maximumFractionDigits:2});
  });
});
